import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import moment from 'moment'

import NoCertiAvailable from '../../../images/NoCertiAvailable.svg';
import JioLoader from "../../../images/JioLoader.svg";
import config from '../../../config.json';
import { vaccinationApiRequestBody } from '../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';
import apiRequest from '../../../utils/api.request';
import useTranslation from '../../../hooks/use-translation';
import { parseQueryString } from '../../../utils/utils';

import './getLastVaccinationDetails.css';

const previousVaccineDataMap = new Map([
  ["certificate verification failed", "Certificate Verification Failed"],
  ["processed success", "Certificate Successfully Processed"],
  ["Successfully Processed internal error", "Unable to Process Certificate"],
  ["invalid_document", "Unable to Process Certificate"],
])

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;

const GetLastVaccinationDetails = ({ hideImage = false, classForStylingButton = "", classForStylingPrevVacc = "", guideTextAfterUpload = "", classForStylingLoader = "" }) => {
  const { t } = useTranslation();
  const [showPreviousVaccinationDetails, _setShowPreviousVaccinationDetails] = useState(false);
  const [noCertificateFound, _setNoCertificateFound] = useState(false);
  const [previousVaccinationStatus, _setPreviousVaccinationStatus] = useState("");
  const [previousVaccinationTimeStamp, _setPreviousVaccinationTimeStamp] = useState("");
  const [showVaccinationDetailsLoader, _setShowVaccinationDetailsLoader] = useState(false);
  const params = parseQueryString();


  const _getCertificateUploadStatus = async () => {
    const url = config.covid_vacc_base_url + "v1/get-covid-certi-upload-status/"
    switch (source_id) {
      case "emp_xp": {
        if (!auth_token || !source_user_id || !source_relation || (source_user_relation_id == undefined)) {
          return;
        }
        const userDetailsObject = {
          auth_token,
          source_id,
          source_user_id,
          source_relation,
          source_user_relation_id
        }
        const dataObj = vaccinationApiRequestBody({}, userDetailsObject);
        _setShowVaccinationDetailsLoader(true);
        const response = await apiRequest(url, dataObj, true);
        _setShowVaccinationDetailsLoader(false);
        if (lodash.get(response, "status") !== "success") {
          return;
        }
        const previousData = lodash.get(response, "data", []);
        if (Array.isArray(previousData) && !previousData.length) {
          _setShowPreviousVaccinationDetails(false);
          _setNoCertificateFound(true);
        } else {
          _setNoCertificateFound(false);
          _setPreviousVaccinationStatus(previousVaccineDataMap.get(previousData[0].status));
          const newTimestamp = moment(previousData[0].processed_at).format("DD/MM/YYYY hh:mm a");
          _setPreviousVaccinationTimeStamp(newTimestamp);
          _setShowPreviousVaccinationDetails(true);
        }
        break;
      }
      case "jiohealthhub": {
        if (!auth_token || !source_user_id) {
          return;
        }
        const userDetailsObject = {
          auth_token,
          source_id,
          jhh_id: source_user_id,
        }
        const dataObj = vaccinationApiRequestBody({}, userDetailsObject);
        _setShowVaccinationDetailsLoader(true);
        const response = await apiRequest(url, dataObj, true);
        _setShowVaccinationDetailsLoader(false);
        if (lodash.get(response, "status") !== "success") {
          return;
        }
        const previousData = lodash.get(response, "data", []);
        if (Array.isArray(previousData) && !previousData.length) {
          _setShowPreviousVaccinationDetails(false);
          _setNoCertificateFound(true);
        } else {
          _setNoCertificateFound(false);
          _setPreviousVaccinationStatus(previousVaccineDataMap.get(previousData[0].status));
          const newTimestamp = moment(previousData[0].processed_at).format("DD/MM/YYYY hh:mm a");
          _setPreviousVaccinationTimeStamp(newTimestamp);
          _setShowPreviousVaccinationDetails(true);
        }
        break;
      }
      default:
        break;
    }
  }

  useEffect(() => {
    auth_token = lodash.get(params, "auth_token");
    source_id = lodash.get(params, "source_id").toLowerCase();
    source_user_id = lodash.get(params, "source_user_id");
    source_relation = lodash.get(params, "source_relation");
    source_user_relation_id = lodash.get(params, "source_user_relation_id");
  }, [])

  return (
    <>
      <div className={`last-vaccination-details-button ${classForStylingButton}`} onClick={_getCertificateUploadStatus}>{t("GET_LAST_VACCINATION_DETAILS")}</div>
      {!guideTextAfterUpload && <br />}
      {guideTextAfterUpload && <div className="last-vaccination-guide-text">{guideTextAfterUpload}</div>}
      {showVaccinationDetailsLoader
        ? <div className={classForStylingLoader}><img className="vaccination-details-loader" src={JioLoader} alt="Loading" /></div>
        : noCertificateFound
          ? <div className="no-certificate-found">{t("NO_CERTIFICATE_FOUND")}</div>
          : showPreviousVaccinationDetails
            ? <div className={`prev-vacc-details-div ${classForStylingPrevVacc}`}>
              <div className="prev-vacc-details-header">{t("UPLOADED_VACCINE_CERTIFICATE_DETAILS")}</div>
              <div className="prev-vacc-details-body">
                <div className="prev-vacc-details-status-header">{t("STATUS")}</div>
                <div className="prev-vacc-details-status-content">{previousVaccinationStatus}</div>
                <div className="prev-vacc-details-timestamp-header">{t("UPLOADED_DATE_AND_TIME")}</div>
                <div className="prev-vacc-details-timestamp-content">{previousVaccinationTimeStamp}</div>
              </div>

            </div>
            : <>
              { hideImage ?
                <></>
                :
                <img src={NoCertiAvailable} alt="No Certificate Image" />
              }
            </>
      }
    </>
  )
}

export default GetLastVaccinationDetails;